import secrets from '../../data/secrets'
import Secret from '../../models/Secret'

// initial state
const state = () => ({

})

// getters
const getters = {
    stats: () => {
        const secrets = Secret.all()
        const stats = {}
        stats.total = secrets.map(secret => secret.total).reduce((prev, next) => prev + next)
        stats.completed = secrets.map(secret => secret.completed).reduce((prev, next) => prev + next)
        stats.progress = Math.round(stats.completed / stats.total * 100)
        return stats
    },
    filtered: (state, getters, rootState) => {
        switch (rootState.configurations.filter) {
            case "completed":
                return Secret.query().where((secret) => secret.completed == secret.total).get()
            case "uncompleted":
                return Secret.query().where((secret) => secret.completed < secret.total).get()
            default:
                return Secret.all();
        }
    }
}

// actions
const actions = {
    load({ commit }) {
        commit('load', secrets)
    },
    increment({ commit }, secret) {
        commit('increment', { secret })
    },
    decrement({ commit }, secret) {
        commit('decrement', { secret })
    }
}

// mutations
const mutations = {
    load(state, secrets) {
        // Restore completed secrets
        secrets.forEach(secret => {
            const persistedSecret = Secret.query().where((persistedSecret) => { return persistedSecret.area_id == secret.area_id }).first()
            if (persistedSecret) {
                secret.completed = persistedSecret.completed
            }
        });
        Secret.create({
            data: secrets
        })
    },
    increment(state, { secret }) {
        if (secret.completed < secret.total) {
            Secret.update({
                where: secret.area_id,
                data: {
                    completed: secret.completed + 1
                }
            })
        }
    },
    decrement(state, { secret }) {
        if (secret.completed > 0) {
            Secret.update({
                where: secret.area_id,
                data: {
                    completed: secret.completed - 1
                }
            })
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}